require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-dynamics-365-update-service.json") })
        }
      }, "path---service-dynamics-365-update-service");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-dynamics-365-update-service!./.cache/json/service-dynamics-365-update-service.json
// module id = 911
// module chunks = 231608221292675